import {UPDATE_ITEMS} from "../../../reducers/robotsAndVehiclesReducer";


export const updateItems = (items) =>{
    return {
        type: UPDATE_ITEMS,
        payload: {items}
    }
}